import { create } from 'zustand'

type TAppListStore = {
  searchValue: string
  setSearchValue: (value: string) => void
  resetSearchValue: () => void
}

export const useAppListStore = create<TAppListStore>()(set => ({
  searchValue: '',
  setSearchValue: searchValue => set({ searchValue }),
  resetSearchValue: () => set({ searchValue: '' })
}))
